(function () {
  "use strict";

  function initExpandable(containerSelector, toggleSelector, contentSelector) {
    document.querySelectorAll(containerSelector).forEach(function (container) {
      if (container.dataset.seoInit) return;
      container.dataset.seoInit = "1";

      var toggle = container.querySelector(toggleSelector);
      var content = container.querySelector(contentSelector);
      if (!toggle || !content) return;

      var expandedText = toggle.getAttribute("data-expanded-text") || "See Less";
      var collapsedText = toggle.getAttribute("data-collapsed-text") || "See More";
      var textSpan = toggle.querySelector("span");

      toggle.addEventListener("click", function () {
        var isCollapsed = content.classList.contains("is-collapsed");
        if (isCollapsed) {
          content.style.maxHeight = content.scrollHeight + "px";
          content.classList.remove("is-collapsed");
          toggle.classList.add("is-expanded");
          toggle.setAttribute("aria-expanded", "true");
          if (textSpan) textSpan.textContent = expandedText;
        } else {
          content.classList.add("is-collapsed");
          content.style.maxHeight = "";
          toggle.classList.remove("is-expanded");
          toggle.setAttribute("aria-expanded", "false");
          if (textSpan) textSpan.textContent = collapsedText;
        }
      });
    });
  }

  function initFaq() {
    document.querySelectorAll(".homepage-faq__item").forEach(function (item) {
      if (item.dataset.faqInit) return;
      item.dataset.faqInit = "1";

      var question = item.querySelector(".homepage-faq__question");
      if (!question) return;

      question.addEventListener("click", function () {
        var wasOpen = item.classList.contains("is-open");
        var list = item.closest(".homepage-faq__list");

        list.querySelectorAll(".homepage-faq__item").forEach(function (i) {
          i.classList.remove("is-open");
          var btn = i.querySelector(".homepage-faq__question");
          if (btn) btn.setAttribute("aria-expanded", "false");
          var ans = i.querySelector(".homepage-faq__answer");
          if (ans) ans.setAttribute("aria-hidden", "true");
        });

        if (!wasOpen) {
          item.classList.add("is-open");
          question.setAttribute("aria-expanded", "true");
          var answer = item.querySelector(".homepage-faq__answer");
          if (answer) answer.setAttribute("aria-hidden", "false");
        }
      });
    });
  }

  function initAll() {
    initExpandable(
      ".collection-seo-description",
      ".seo-toggle-btn",
      ".collection-seo-description__content"
    );
    initExpandable(
      ".homepage-seo-content",
      ".seo-toggle-btn",
      ".homepage-seo-content__body"
    );
    initFaq();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
